
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import functionUncurryThis from './function-uncurry-this.js';
import aCallable$1 from './a-callable.js';

var uncurryThis = functionUncurryThis;
var aCallable = aCallable$1;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

export { functionUncurryThisAccessor as default };
//# sourceMappingURL=function-uncurry-this-accessor.js.map
